<template>
<popup-full @close="$emit('close')">

  <template #title class="alignC">{{title}}</template>

  <template #content>
    <TermContent :termType="type"/>
    <!-- <div v-html="content"></div> -->
  </template>

  <template #button>
    <a @click="$emit('agreeTerms')" class="btnL">동의</a>
  </template>
  
</popup-full>
</template>
<script>
import PopupFull from './PopupFull.vue';
import TermContent from '../Term/TermContent.vue'

export default {
  components: {
    PopupFull,
    TermContent
  },
  props: {
    title: { type: String },
    type: { type: String ,default:null }
  },
  computed:{
  }
}
</script>

<style lang="css" scoped>
</style>